import { render, staticRenderFns } from "./ScienceAndEngineeringSvg.vue?vue&type=template&id=3032c9bf&"
import script from "./ScienceAndEngineeringSvg.vue?vue&type=script&lang=ts&"
export * from "./ScienceAndEngineeringSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3032c9bf', component.options)
    } else {
      api.reload('3032c9bf', component.options)
    }
    module.hot.accept("./ScienceAndEngineeringSvg.vue?vue&type=template&id=3032c9bf&", function () {
      api.rerender('3032c9bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/paywall/svgs/ScienceAndEngineeringSvg.vue"
export default component.exports